import { MEDIA_QUERY } from 'config/constants'
import { Color, Gap, Responsive, Size } from 'const'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import purchasesAPI from 'utils/axios/modules/purchases'
import { paginationChunks } from 'utils/paginations'
import { Pagination } from 'components/shard/Pagination.jsx'
import { Banner, Logout, Receipt } from 'components/shard'
import { compareDesc } from 'date-fns'

const PurchaseHistories = () => {
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  /* ブラウザバックに対応するために pageIndex をpathパラメータから取得 */
  const location = useLocation()
  const pageIndex = location.search.split('=')[1] || 0
  const [chunkIndex, setChunkIndex] = useState(parseInt(pageIndex))

  useEffect(() => {
    void (async () => {
      setIsLoading(true)
      try {
        const response = await purchasesAPI.getHistories()
        if (!response.data) throw new Error('データがありません')
        setItems(
          response.data
            .sort((a, b) => compareDesc(new Date(a.sales_date), new Date(b.sales_date)))
            .filter((item) => item.is_ninal_contracts === false)
        )
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    })()
  }, [])

  const chunkItems = useMemo(() => {
    const chunks = paginationChunks({ array: items, chunkSize: 8 }) // 8項目ずつに分割

    return chunks
  }, [items])

  return (
    <MainBlock className="purchase-container">
      <Announcement>保証書や取扱説明書はクリックでご確認できます。</Announcement>
      <ServiceWrapper>
        {isLoading ? (
          <ServiceBlock>
            <Information>ご購入履歴を確認中。</Information>
          </ServiceBlock>
        ) : (
          <ServiceBlock>
            {items.length ? (
              <GridBlock>
                {chunkItems[chunkIndex].map((item, index) => (
                  <Receipt receipt={item} key={index} />
                ))}
              </GridBlock>
            ) : (
              <Information>購入履歴はありません。</Information>
            )}
            <Pagination chunkIndex={chunkIndex} setChunkIndex={setChunkIndex} max={chunkItems.length} />
          </ServiceBlock>
        )}
      </ServiceWrapper>
      <Banner />
      <Logout />
    </MainBlock>
  )
}

const MainBlock = styled.div``

const ServiceWrapper = styled.div`
  background-color: ${Color.BACKGROUND.BLOCK};
  @media screen and (max-width: ${Responsive.MD.DOWN}px) {
    padding: 24px ${Gap.XLG};
  }
`

const ServiceBlock = styled.div`
  ${MEDIA_QUERY.PC} {
    padding: 57px 24px 40px 24px;
    border-radius: 10px;
    border: 1px solid ${Color.LINE.NORMAL};
  }
  ${MEDIA_QUERY.SP} {
    position: relative;
    height: 100%;
  }
  margin-bottom: ${Size.PADDING.APP};
`

const Announcement = styled.div`
  font-size: ${Size.FONT.BIG};
  padding: 0 0 30px;
  white-space: pre-line;
  font-weight: 500;

  @media screen and (max-width: ${Responsive.MD.DOWN}px) {
    padding: 0 20px 30px;
  }
`

const GridBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${Gap.LG};

  @media screen and (max-width: ${Responsive.MD.DOWN}px) {
    grid-template-columns: 1fr;
  }
`

const Information = styled.div`
  text-align: center;
  ${MEDIA_QUERY.PC} {
    padding: 2px 0 62px 0;
  }
  ${MEDIA_QUERY.SP} {
    padding: 40px 0px;
  }
`
export default PurchaseHistories
